import React from 'react';
import moment from 'moment';

interface DateTimeProps {
  value?: string;
}

const DateTime = ({ value }: DateTimeProps) => {
  return <>{moment(value).format('D. M. YYYY o H:mm')}</>;
};

export default DateTime;
